export default __webpack_public_path__ + "static/media/383534d2-68d6-43bb-8ca2-45127018845c.42595d04.webp";